<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="车型：" prop="model_type">
                <el-select clearable v-model="model.model_type" placeholder="请选择">
                    <el-option v-for="item in enuObj('model_type')" :key="'model_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="电商平台：" prop="shop_platform">
                <el-select clearable v-model="model.shop_platform" placeholder="请选择">
                    <el-option v-for="item in enuObj('shop_platform')" :key="'shop_platform'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="标题：" prop="title">
                <el-input v-model="model.title"></el-input>
            </el-form-item>
            <el-form-item label="描述：" prop="ftitle">
                <el-input v-model="model.ftitle"></el-input>
            </el-form-item>
            <el-form-item label="链接：" prop="link">
                <el-input type="textarea" raws="3" v-model="model.link"></el-input>
            </el-form-item>
            <el-form-item label="口令：" prop="tpwd">
                <el-input type="textarea" rows="4" v-model="model.tpwd"></el-input>
            </el-form-item>
            <el-form-item label="状态：" prop="state">
                <el-select clearable v-model="model.state" placeholder="请选择">
                    <el-option v-for="item in enuObj('goods_state')" :key="'goods_state'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排序：" prop="order_index">
                <el-input v-model.number="model.order_index"></el-input>
            </el-form-item>
            <el-form-item label="图片1：" prop="img1">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess1"
                    :before-upload="beforeUpload">
                    <img v-if="model.img1" :src="model.img1" class="upImg" style="width: 225px;height: 180px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 225px;height: 180px;line-height: 180px"></i>
                    <div slot="tip" class="el-upload__tip">建议尺寸：750px * 600px</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="图片2：" prop="img2">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess2"
                    :before-upload="beforeUpload">
                    <img v-if="model.img2" :src="model.img2" class="upImg" style="width: 225px;height: 180px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 225px;height: 180px;line-height: 180px"></i>
                    <div slot="tip" class="el-upload__tip">建议尺寸：750px * 600px</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="图片3：" prop="img3">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess3"
                    :before-upload="beforeUpload">
                    <img v-if="model.img3" :src="model.img3" class="upImg" style="width: 225px;height: 180px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 225px;height: 180px;line-height: 180px"></i>
                    <div slot="tip" class="el-upload__tip">建议尺寸：750px * 600px</div>
                </el-upload>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import config from '@/config'
import { saveModel } from '@/api/common'

export default {
    name: 'goodsEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                model_type: 'Model 3',
                shop_platform: '1',
                title: '',
                ftitle: '',
                link: '',
                tpwd: '',
                img1: '',
                img2: '',
                img3: '',
                state: '1',
                order_index: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/goodsjd/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['goods_state', 'shop_platform','model_type'],
            rules: {
                model_type: [
                    {required: true, message: '车型不能为空', trigger: 'blur'}
                ],
                shop_platform: [
                    {required: true, message: '电商平台不能为空', trigger: 'blur'}
                ],
                title: [
                    {required: true, message: '标题不能为空', trigger: 'blur'}
                ],
                ftitle: [
                    {required: true, message: '描述不能为空', trigger: 'blur'}
                ],
                tpwd: [
                    {required: true, message: '口令不能为空', trigger: 'blur'}
                ],
                state: [
                    {required: true, message: '状态不能为空', trigger: 'blur'}
                ],
                order_index: [
                    {required: true, message: '排序不能为空', trigger: 'blur'},
                    {type: 'number', message: '排序必须是数字值', trigger: 'blur'}
                ],
                img1: [
                    {required: true, message: '图片1不能为空', trigger: 'blur'}
                ],
                img2: [
                    {required: true, message: '图片2不能为空', trigger: 'blur'}
                ],
                img3: [
                    {required: true, message: '图片3不能为空', trigger: 'blur'}
                ],
            },
            uploadAction: config.uploadAction,
            uploadData: {
                folder: "goods",
            },
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/goods/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        handleUploadSuccess1(res, file){
            if(res.code ==1){
                this.model.img1 = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
        handleUploadSuccess2(res, file){
            if(res.code ==1){
                this.model.img2 = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
        handleUploadSuccess3(res, file){
            if(res.code ==1){
                this.model.img3 = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
        formateData() {
            this.model.state = this.model.state+''
            this.model.shop_platform = this.model.shop_platform+''
        },
    }
};
</script>